import gsap from 'gsap';
import { connectHits } from 'instantsearch.js/es/connectors';

const handleMouseEnter = (e) => {
    const cell = e.target.closest('a');
    if (cell) {
        const { color } = cell.dataset;
        gsap.to(cell, {
            duration: 0.2,
            boxShadow: `inset 0 0 0 4px ${color}`,
            borderColor: color,
            ease: 'power2.out',
        });
    }
};

const handleMouseLeave = (e) => {
    const cell = e.target.closest('a');
    if (cell) {
        gsap.to(cell, {
            duration: 0.2,
            boxShadow: 'none',
            borderColor: '#bcbcbc',
            ease: 'power2.out',
        });
    }
};

// create the render function
const renderHits = (renderOptions) => {
    const { hits, results, widgetParams } = renderOptions;

    // no results
    if (hits.length === 0) {
        widgetParams.container.innerHTML = '';
        return;
    }

    // build URL parameters
    const parameters = [];

    results.getRefinements().forEach((refinement) => {
        const { attributeName, name } = refinement;
        parameters.push(`${attributeName}=${name}`);
    });

    // Remove existing event listeners if they exist
    widgetParams.container.removeEventListener('mouseenter', handleMouseEnter, true);
    widgetParams.container.removeEventListener('mouseleave', handleMouseLeave, true);

    // Cache all HTML first
    const cellsHTML = hits.map((item) => `
        <a
            href="${item.url}${parameters.length > 0 ? `?${parameters.join('&')}` : ''}" 
            class="flex flex-col items-center h-auto py-10 px-5 border bg-white rounded-xl text-center"
            data-color="${item.colour}">
            ${item.image ? `
                <img
                    src="${item.image}"
                    class="w-full max-w-72 px-5 mb-3">
            ` : ''}
            <h2 class="mb-5 text-2xl">
                <img
                    src="${item.logo}"
                    class="w-full max-w-80 max-h-6 mb-1.5 object-contain">
                <span class="sr-only">${item.title}</span>
            </h2>
            ${item.short_description ? `<p>${item.short_description}</p>` : ''}
            ${item.presale ? `<p class="max-w-48 mt-6 text-xs font-semibold">*${item.presale_message}</p>` : ''}
        </a>
    `).join('');

    widgetParams.container.innerHTML = cellsHTML;

    // Add new event listeners
    widgetParams.container.addEventListener('mouseenter', handleMouseEnter, true);
    widgetParams.container.addEventListener('mouseleave', handleMouseLeave, true);
};

// create the custom widget
const customHits = connectHits(renderHits);

export default customHits;
